<div *ngIf="tableRendered" class="py-1 w-100" style="border-top: 1px #e2e2e2 solid; border-bottom: 1px #e2e2e2 solid">
	<button
		[title]="isAllArchived() ? 'Przywróć' : 'Archiwizuj'"
		color="primary"
		class="archive-button"
		(click)="archiveThreads()"
		[disabled]="messageTableRef.selection.isEmpty()"
		mat-icon-button
	>
		<ng-container *ngIf="!service.archiveAllLoading; else spinner">
			<ng-container *ngIf="isAllArchived(); else activeThreads">
				<i class="fas fa-undo-alt"></i>
			</ng-container>
			<ng-template #activeThreads>
				<i class="fas fa-archive"></i>
			</ng-template>
		</ng-container>

		<ng-template #spinner>
			<div class="d-flex justify-content-center">
				<mat-spinner diameter="20"></mat-spinner>
			</div>
		</ng-template>
	</button>
	<!--	comment for now, waiting for Puksi-->
	<!--	<button-->
	<!--		[disabled]="-->
	<!--			messageTables?.get(this.tabGroup.selectedIndex).selection.isEmpty()-->
	<!--		"-->
	<!--		title="Oznacz jako przeczytane"-->
	<!--		color="primary"-->
	<!--		class="read-button"-->
	<!--		mat-icon-button-->
	<!--	>-->
	<!--		<i class="fas fa-envelope-open"></i>-->

	<!--		<ng-template #spinner>-->
	<!--			<div class="d-flex justify-content-center">-->
	<!--				<mat-spinner diameter="20"></mat-spinner>-->
	<!--			</div>-->
	<!--		</ng-template>-->
	<!--	</button>-->
	<button
		[disabled]="messageTableRef.selection.isEmpty()"
		[title]="messageTableRef.isWatchedSelectedThreads() ? 'Przestań obserwować' : 'Obserwuj'"
		color="primary"
		class="watch-button"
		mat-icon-button
		(click)="watchThreads()"
	>
		<ng-container *ngIf="!service.watchAllLoading; else spinner">
			<ng-container *ngIf="messageTableRef.isWatchedSelectedThreads(); else notWatching">
				<i class="fas fa-heart"></i>
			</ng-container>
			<ng-template #notWatching>
				<i class="far fa-heart"></i>
			</ng-template>
		</ng-container>
		<ng-template #spinner>
			<div class="d-flex justify-content-center">
				<mat-spinner diameter="20"></mat-spinner>
			</div>
		</ng-template>
	</button>
	<button
		[disabled]="messageTableRef.selection.isEmpty()"
		title="Przypisz użytkownika"
		color="primary"
		class="assign-me-button"
		mat-icon-button
		(click)="openAssignUserDialog()"
	>
		<i class="fas fa-user"></i>
	</button>
	<button
		[disabled]="messageTableRef.selection.isEmpty()"
		title="Przypisz rezerwacje"
		color="primary"
		class="assign-reservation-button"
		mat-icon-button
		(click)="openAssignReservationDialog()"
	>
		<i class="fas fa-suitcase-rolling"></i>
	</button>
</div>
<!--hidden for now-->
<!--<mat-tab-group-->
<!--	(selectedTabChange)="onTabChanged($event)"-->
<!--	animationDuration="0ms"-->
<!--&gt;-->
<!--	<ng-container *ngFor="let tab of tabs">-->
<!--		<mat-tab [label]="tab.textLabel"></mat-tab>-->
<!--	</ng-container>-->
<!--</mat-tab-group>-->
<app-message-table #messageTableRef class="position-relative"></app-message-table>
